// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2AgTr","rootSuccess":"CompleteLink_rootSuccess__2Rkxf","rootFailure":"CompleteLink_rootFailure__3P_xW","isDisabled":"CompleteLink_isDisabled__10zR9"};